


 




 

"use client";

import { useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import Link from "next/link";
import { useTheme } from "@/app/context/ThemeContext";

interface ImageItem {
  id: number;
  url: string;
}

interface HeroData {
  title: string;
  subtitle: string;
  cta_primary: string;
  cta_secondary: string;
  images: ImageItem[];
}


function FeatureItemm({ icon, textone, texttwo, links }: { icon: string; links: string; textone: string, texttwo: string }) {
  const { theme } = useTheme();
  return (
    <Link href={links} className="flex items-start gap-3">
      <div className="flex flex-col items-center space-y-1">
        <span className="text-green-300 text-2xl">{icon}</span>
        <p className="font-semibold text-sm">{textone}</p>
        <p className="text-xs opacity-80">{texttwo}</p>
      </div>
    </Link>

  );
}
function FeatureItem({ icon, textone, texttwo }: { icon: string; textone: string, texttwo: string }) {
  const { theme } = useTheme();
  return (
    <div className="flex flex-col items-center space-y-1">
      <span className="text-green-300 text-2xl">{icon}</span>
      <p className="font-semibold text-sm">{textone}</p>
      <p className="text-xs opacity-80">{texttwo}</p>
    </div>

  );
}
const featureTranslations = {
  fr: {
    eco_title: "Produits responsables",
    eco_sub: "& écologiques",

    distributors_title: "Des distributeurs",
    distributors_sub: "proches de chez vous",

    family_title: "Entreprise National",
    family_sub: "depuis près de 43 ans",

    question_title: "Une question ?",
    question_sub: "Contactez-nous",
  },
  en: {
    eco_title: "Responsible products",
    eco_sub: "& eco-friendly",

    distributors_title: "Distributors",
    distributors_sub: "near you",

    family_title: "National company",
    family_sub: "for nearly 40 years",

    question_title: "A question?",
    question_sub: "Contact us",
  },
  ar: {
    eco_title: "منتجات مسؤولة",
    eco_sub: "وصديقة للبيئة",

    distributors_title: "موزعون",
    distributors_sub: "قريبون منك",

    family_title: "مؤسسة وطنية ",
    family_sub: "منذ ما يقارب 40 سنة",

    question_title: "هل لديك سؤال؟",
    question_sub: "اتصل بنا",
  },
};


 
export default function Hero() {
  const { language } = useLanguage();
  const [data, setData] = useState<HeroData | null>(null);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
const t = featureTranslations[language as "fr" | "en" | "ar"] || featureTranslations.en;
  /*
  const fetchHeroData = async (lang: string) => {
    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_STRAPI_URL}/api/image-homes?populate=image&locale=${lang}`,
        { cache: "no-store" }
      );
      const json = await res.json();

      if (json.data && json.data.length > 0) {
        const item = json.data[0];

        const images =
          item.image?.map((img: any) => ({
            id: img.id,
            // 🔥 Use the ORIGINAL Strapi image (highest quality)
            url: `${process.env.NEXT_PUBLIC_STRAPI_URL}${img.url}`,
          })) || [];

        setData({
          title: item.title,
          subtitle: item.subtitle,
          cta_primary: item.cta_primary,
          cta_secondary: item.cta_secondary,
          images,
        });
      } else setData(null);
    } catch (err) {
      console.error(err);
      setData(null);
    } finally {
      setLoading(false);
      setCurrentIndex(0);
    }
  };

  useEffect(() => {
    fetchHeroData(language);
  }, [language]);
 */
const fetchHeroData = async (lang: string) => {
  setLoading(true);
  try {
    const res = await fetch(`/api/HomePage?locale=${lang}`, { cache: "no-store" });
    const json = await res.json();

    if (json.data && json.data.length > 0) {
      const item = json.data[0];
      const images =
        item.image?.map((img: any) => ({
          id: img.id,
          url: `${process.env.NEXT_PUBLIC_STRAPI_URL}${img.url}`,
        })) || [];

      setData({
        title: item.title,
        subtitle: item.subtitle,
        cta_primary: item.cta_primary,
        cta_secondary: item.cta_secondary,
        images,
      });
    } else setData(null);
  } catch (err) {
    console.error(err);
    setData(null);
  } finally {
    setLoading(false);
    setCurrentIndex(0);
  }
};

  useEffect(() => {
    fetchHeroData(language);
  }, [language]);
 

  useEffect(() => {
    if (!data?.images?.length) return;

    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % data.images.length);
        setIsTransitioning(false);
      }, 500);
    }, 6000);

    return () => clearInterval(interval);
  }, [data?.images]);

  const goToSlide = (index: number) => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex(index);
      setIsTransitioning(false);
    }, 300);
  };

  const nextSlide = () => {
    if (!data?.images) return;
    goToSlide((currentIndex + 1) % data.images.length);
  };

  const prevSlide = () => {
    if (!data?.images) return;
    goToSlide((currentIndex - 1 + data.images.length) % data.images.length);
  };

  if (loading) {
    return (
      <div className="relative w-full h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center">
        <div className="animate-pulse flex flex-col items-center space-y-4">
          <div className="w-32 h-32 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full animate-spin border-4 border-transparent border-t-white"></div>
          <p className="text-white text-lg">Loading stunning visuals...</p>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="relative w-full h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center text-white">
        <div className="text-center">
          <div className="text-6xl mb-4">📷</div>
          <p className="text-xl">{language.toUpperCase()}</p>
        </div>
      </div>
    );
  }

  return (
    <section className="relative w-full h-[80vh] overflow-hidden">
      {data.images.length > 0 && (
        <div className="relative w-full h-full">

           <div
            className={`absolute inset-0 w-full h-full transform transition-all duration-1000 ease-out ${
              isTransitioning ? "scale-105 opacity-90" : "scale-100 opacity-100"
            }`}
            style={{
              backgroundImage: `url(${data.images[currentIndex].url})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              // 🔥 Removed fixed → sharpness restored
              backgroundAttachment: "scroll",
            }}
          />

           <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-black/20" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/40" />

           <div className="absolute inset-0 opacity-20">
            {[...Array(15)].map((_, i) => (
              <div
                key={i}
                className="absolute w-2 h-2 bg-white rounded-full animate-pulse"
                style={{
                  top: `${Math.random() * 100}%`,
                  left: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 5}s`,
                  animationDuration: `${3 + Math.random() * 4}s`,
                }}
              />
            ))}
          </div>

           <div className="relative z-10 w-full h-full flex flex-col justify-center items-center px-4 sm:px-6 lg:px-8">
            <div
              className={`text-center text-white transform transition-all duration-1000 ${
                isTransitioning ? "translate-y-10 opacity-0" : "translate-y-0 opacity-100"
              }`}
            >
              <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-6 tracking-tight">
                <span className="bg-gradient-to-r from-white via-blue-100 to-cyan-100 bg-clip-text text-transparent">
                  {data.title}
                </span>
              </h1>

              <div className="relative mb-8">
                <p className="text-xl md:text-2xl lg:text-3xl font-light max-w-4xl mx-auto leading-relaxed">
                  {data.subtitle}
                </p>
                <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-blue-500 to-cyan-400 rounded-full" />
              </div>

 <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-12">
  <a
    href="#specialties"
    className="group relative bg-white/10 backdrop-blur-md border border-white/20 hover:border-white/30 text-white px-8 py-4 rounded-2xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 hover:bg-white/15 shadow-xl hover:shadow-2xl overflow-hidden"
  >
    <span className="relative z-10 flex items-center space-x-2">
      <span>{data.cta_primary}</span>
      <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
      </svg>
    </span>
  </a>

  <a
    href="/about"
    className="group relative backdrop-blur-md border-2 border-white/40 hover:border-white/60 bg-transparent hover:bg-white/5 text-white px-8 py-4 rounded-2xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
  >
    <span className="flex items-center space-x-2">
      <span>{data.cta_secondary}</span>
      <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
      </svg>
    </span>
  </a>
</div>
            </div>
          </div>

           <div className="absolute bottom-0 left-0 w-full z-20">
            <div className="w-full bg-white/10 backdrop-blur-md border-t border-white/20 py-4">
       <div
  dir={language === "ar" ? "rtl" : "ltr"}
  className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-white text-center"
>
  <FeatureItem icon="♻️" textone={t.eco_title} texttwo={t.eco_sub} />

  <FeatureItemm
    icon="📍"
    textone={t.distributors_title}
    texttwo={t.distributors_sub}
    links="/locate-us"
  />

  <FeatureItem icon="🏠" textone={t.family_title} texttwo={t.family_sub} />

  <FeatureItemm
    icon="❓"
    textone={t.question_title}
    texttwo={t.question_sub}
    links="/contact"
  />
</div>
            </div>
          </div>

           {data.images.length > 1 && (
            <>
              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 z-20 w-12 h-12 bg-black/30 hover:bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110 group"
              >
                <svg className="w-6 h-6 transform group-hover:-translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>

              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 z-20 w-12 h-12 bg-black/30 hover:bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110 group"
              >
                <svg className="w-6 h-6 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </>
          )}

           {data.images.length > 1 && (
            <div className="absolute bottom-16 left-1/2 transform -translate-x-1/2 z-20 flex space-x-3">
              {data.images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 transform hover:scale-125 ${
                    index === currentIndex ? "bg-white scale-125" : "bg-white/50 hover:bg-white/80"
                  }`}
                />
              ))}
            </div>
          )}

           <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-20">
            <div className="animate-bounce w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
              <div className="w-1 h-3 bg-white/70 rounded-full mt-2" />
            </div>
          </div>

           <div className="absolute top-8 right-8 z-20">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-4 py-3">
              <p className="text-white text-sm font-medium">
                {currentIndex + 1} / {data.images.length}
              </p>
            </div>
          </div>

        </div>
      )}

      {isTransitioning && (
        <div className="absolute inset-0 z-30 bg-black/20 backdrop-blur-sm flex items-center justify-center">
          <div className="w-16 h-16 border-4 border-white/30 border-t-white rounded-full animate-spin" />
        </div>
      )}
    </section>
  );
}

 




 